// extracted by mini-css-extract-plugin
export default {"lens-ui-font-definition":"IAbJ7FkNG2PgyzQu0Q9J","lensUiFontDefinition":"IAbJ7FkNG2PgyzQu0Q9J","bottom-navigation":"Hiy_eCIoKEPOUZIe0deE","bottomNavigation":"Hiy_eCIoKEPOUZIe0deE"};